/**
 * Map of page name to route ids for server events
 */
export const routeMap = {
  disclaimer: 20000,
  'address-info': 20015,
  'move-combined': [20031, 20040, 20041, 20043, 20044, 20030, 20010, 20042],
  'move-combined-mobile': [20031, 20040, 20041, 20043, 20044, 20030, 20010, 20042],
  'contact-info': 20025,
  'additional-services': 20035,
  'verify-info-read': 20045,
  'verify-info-edit': 20046,
  'age-verification': 20110,
  'identity-check': 20110,
  payment: 2118,
  'instant-savings': 1471,
  'confirm-order': 2420,
  'military-confirm': 2420,

  // ERROR routes
  'processing-error': 500,
  'fatal-error': 500,
  'session-unavailable': 500,
  cmra: 500,
  'old-unique-zip': 500,
  'residential-business': 500,
};
